import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-rent_release",
  "use": "icon-rent_release-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-rent_release\">\r\n<path d=\"M6.7,12.5L0.3,8.6L19.7,1l-3.4,17.5L8,13.1l7.4-8L6.7,12.5z M8.1,14.6V19l2.7-2.8L8.1,14.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol